var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("bj-crud-form-modal", {
        ref: "crudModal",
        attrs: {
          model: "User",
          "endpoint-create": "admin/agents",
          "endpoint-edit": "users",
          fields: _vm.fields,
          "edit-fields": _vm.editFields,
          "date-fields": _vm.dateFields,
          callback: _vm.beforeSave,
          "not-crud": ""
        },
        on: {
          saved: function($event) {
            _vm.$refs.dataTable.refresh()
          }
        }
      }),
      _vm.addAgentsDialog.visible
        ? _c("addAgentsDialog", {
            attrs: { "add-agent-dialog": _vm.addAgentsDialog },
            on: {
              close: function($event) {
                _vm.addAgentsDialog.visible = false
              }
            }
          })
        : _vm._e(),
      _c("q-btn", {
        staticClass: "q-mb-md",
        attrs: {
          size: "md",
          rounded: "",
          outline: "",
          color: "positive",
          icon: "mail",
          label: "Add agents from CSV"
        },
        nativeOn: {
          click: function($event) {
            _vm.addAgentsDialog.visible = true
          }
        }
      }),
      _c("div", { staticClass: "row full-row-exactly" }, [
        _c("div", { staticClass: "col-12 flex-1" }, [
          _c(
            "div",
            {
              staticClass: "gutter-sm",
              class: _vm.$q.screen.lt.md ? "column" : "row"
            },
            [
              _vm.$q.screen.lt.md || _vm.showFiltersDesktop
                ? _c(
                    "div",
                    {
                      class:
                        _vm.$q.screen.lt.md && !_vm.showFiltersMobile
                          ? "col-auto"
                          : "col-md-3"
                    },
                    [
                      _c(
                        "q-card",
                        { class: _vm.$q.screen.gt.sm ? "full-height" : "" },
                        [
                          _c("q-card-title", [
                            _c("div", { staticClass: "row" }, [
                              _c("div", { staticClass: "col" }, [
                                _vm._v(
                                  "\n                  Filters\n                "
                                )
                              ]),
                              _vm.$q.screen.lt.md
                                ? _c(
                                    "div",
                                    { staticClass: "col-auto q-mr-auto" },
                                    [
                                      _c("q-btn", {
                                        attrs: {
                                          color: "secondary",
                                          flat: "",
                                          round: "",
                                          icon:
                                            "keyboard_arrow_" +
                                            (_vm.showFiltersMobile
                                              ? "up"
                                              : "down")
                                        },
                                        on: { click: _vm.toggleFiltersMobile }
                                      })
                                    ],
                                    1
                                  )
                                : _vm._e()
                            ])
                          ]),
                          _vm.$q.screen.gt.sm || _vm.showFiltersMobile
                            ? _c(
                                "q-card-main",
                                {
                                  staticStyle: { height: "calc(100% - 64px)" }
                                },
                                [
                                  _c(
                                    _vm.$q.screen.gt.sm
                                      ? "q-scroll-area"
                                      : "div",
                                    {
                                      tag: "component",
                                      class: {
                                        "full-height": _vm.$q.screen.gt.sm
                                      }
                                    },
                                    [
                                      _c("bj-filters", {
                                        key: _vm.filtersResetReRenderKey,
                                        ref: "filtersModal",
                                        attrs: { fields: _vm.filterFields },
                                        on: {
                                          reset: function($event) {
                                            _vm.filtersResetReRenderKey++
                                          },
                                          input: _vm.initFilters
                                        },
                                        model: {
                                          value: _vm.filters,
                                          callback: function($$v) {
                                            _vm.filters = $$v
                                          },
                                          expression: "filters"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            : _vm._e()
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "div",
                { staticClass: "col" },
                [
                  _c("bj-data-table", {
                    ref: "dataTable",
                    attrs: {
                      "with-cell-delete-button": false,
                      "with-cell-edit-button": false,
                      "add-button-label": "Add Agent",
                      columns: _vm.columns,
                      model: "admin/agents",
                      "many-name": "Agents",
                      "single-name": "Agent",
                      "query-params": _vm.queryParams,
                      "filter-button": ""
                    },
                    on: {
                      "toggle-filters": _vm.toggleFiltersDesktop,
                      add: function($event) {
                        _vm.$refs.crudModal.open("add", _vm.newAgentPayload)
                      }
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "cell-first_name",
                        fn: function(ref) {
                          var row = ref.row
                          return [
                            _c(
                              "router-link",
                              {
                                attrs: {
                                  to: {
                                    name: "app.agents.profile",
                                    params: { id: row.id }
                                  }
                                }
                              },
                              [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(row.full_name) +
                                    "\n              "
                                )
                              ]
                            ),
                            row.is_showami
                              ? _c(
                                  "q-chip",
                                  {
                                    staticClass: "ml-2",
                                    attrs: {
                                      dense: "",
                                      color: "orange",
                                      "text-color": "white"
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n                Showami\n              "
                                    )
                                  ]
                                )
                              : _vm._e()
                          ]
                        }
                      },
                      {
                        key: "cell-admin_notes",
                        fn: function(ref) {
                          var row = ref.row
                          return [
                            row.admin_notes
                              ? _c(
                                  "span",
                                  { attrs: { title: row.admin_notes } },
                                  [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(
                                          row.admin_notes.substring(0, 25) +
                                            (row.admin_notes.length > 25
                                              ? "..."
                                              : "")
                                        ) +
                                        "\n              "
                                    )
                                  ]
                                )
                              : _vm._e()
                          ]
                        }
                      },
                      {
                        key: "cell-muted_until",
                        fn: function(ref) {
                          var row = ref.row
                          return [
                            row.muted_until
                              ? _c(
                                  "q-chip",
                                  { attrs: { small: "", color: "negative" } },
                                  [
                                    _vm._v(
                                      "\n                Muted until\n                " +
                                        _vm._s(
                                          _vm
                                            .moment(row.muted_until)
                                            .tz(
                                              (row.markets || []).length
                                                ? row.markets[0].timezone
                                                : null
                                            )
                                            .format("MM/DD/YY h:mmA")
                                        ) +
                                        "\n                "
                                    ),
                                    (row.markets || []).length
                                      ? _c("q-icon", {
                                          directives: [
                                            {
                                              name: "tippy",
                                              rawName: "v-tippy"
                                            }
                                          ],
                                          staticClass: "ml-1",
                                          attrs: {
                                            name: "access_time",
                                            size: "14px",
                                            title: row.markets[0].timezone
                                          }
                                        })
                                      : _vm._e()
                                  ],
                                  1
                                )
                              : _vm._e()
                          ]
                        }
                      },
                      {
                        key: "cell-blocked",
                        fn: function(ref) {
                          var row = ref.row
                          return [
                            _c("q-checkbox", {
                              on: {
                                input: function($event) {
                                  _vm.blockAgent(row)
                                }
                              },
                              model: {
                                value: row.blocked,
                                callback: function($$v) {
                                  _vm.$set(row, "blocked", $$v)
                                },
                                expression: "row.blocked"
                              }
                            })
                          ]
                        }
                      },
                      {
                        key: "cell-location",
                        fn: function(ref) {
                          var row = ref.row
                          return [
                            row.location
                              ? _c(
                                  "a",
                                  {
                                    directives: [
                                      { name: "tippy", rawName: "v-tippy" }
                                    ],
                                    attrs: {
                                      href:
                                        "https://www.google.com/maps/search/?api=1&query=" +
                                        row.location.coordinates[1] +
                                        "," +
                                        row.location.coordinates[0],
                                      target: "_blank",
                                      title: "Open google maps"
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(row.location.coordinates[1]) +
                                        ",\n                " +
                                        _vm._s(row.location.coordinates[0]) +
                                        "\n              "
                                    )
                                  ]
                                )
                              : _vm._e()
                          ]
                        }
                      },
                      {
                        key: "cell-stripe",
                        fn: function(ref) {
                          var row = ref.row
                          return [
                            row.stripe == null
                              ? _c("span", { staticClass: "text-negative" }, [
                                  _vm._v("Not registered")
                                ])
                              : _vm._e(),
                            row.stripe != null &&
                            row.stripe.data != undefined &&
                            row.stripe.data.stripe_user_id != undefined
                              ? _c("span", [
                                  _vm._v(_vm._s(row.stripe.data.stripe_user_id))
                                ])
                              : _vm._e()
                          ]
                        }
                      },
                      {
                        key: "cell-used_app_at",
                        fn: function(ref) {
                          var row = ref.row
                          return [
                            row.used_app_at
                              ? _c(
                                  "span",
                                  [
                                    _c("SdDatetime", {
                                      attrs: { value: row.used_app_at }
                                    })
                                  ],
                                  1
                                )
                              : _vm._e()
                          ]
                        }
                      },
                      {
                        key: "cell-device",
                        fn: function(ref) {
                          var row = ref.row
                          return [
                            row.device
                              ? _c(
                                  "span",
                                  [
                                    typeof row.device.platform === "string" &&
                                    row.device.platform.toLowerCase() ===
                                      "android"
                                      ? _c("q-icon", {
                                          directives: [
                                            {
                                              name: "tippy",
                                              rawName: "v-tippy"
                                            }
                                          ],
                                          attrs: {
                                            name: "fab fa-android",
                                            color: "green",
                                            title: "Android"
                                          }
                                        })
                                      : typeof row.device.platform ===
                                          "string" &&
                                        row.device.platform.toLowerCase() ===
                                          "ios"
                                      ? _c("q-icon", {
                                          directives: [
                                            {
                                              name: "tippy",
                                              rawName: "v-tippy"
                                            }
                                          ],
                                          attrs: {
                                            name: "fab fa-apple",
                                            title: "iOS"
                                          }
                                        })
                                      : _vm._e(),
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(row.device.model) +
                                        "\n                "
                                    ),
                                    row.device.manufacturer
                                      ? _c("span", [
                                          _vm._v(
                                            _vm._s(
                                              row.device.manufacturer
                                                .charAt(0)
                                                .toUpperCase() +
                                                row.device.manufacturer.slice(1)
                                            )
                                          )
                                        ])
                                      : _vm._e()
                                  ],
                                  1
                                )
                              : _vm._e()
                          ]
                        }
                      },
                      {
                        key: "cell-contact_status",
                        fn: function(ref) {
                          var row = ref.row
                          return [
                            _c("contact-status-dropdown", {
                              ref: "status_" + row.id,
                              attrs: { current: row.contact_status },
                              on: {
                                change: function(state) {
                                  _vm.updateContactStatus(row, state)
                                }
                              }
                            })
                          ]
                        }
                      },
                      {
                        key: "cell-contact_status_updated_at",
                        fn: function(ref) {
                          var row = ref.row
                          return [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "d-flex justify-content-between align-items-center"
                              },
                              [
                                _c(
                                  "div",
                                  { staticClass: "col-auto" },
                                  [
                                    row.contact_status_updated_at
                                      ? _c("SdDatetime", {
                                          staticClass: "d-inline-flex",
                                          attrs: {
                                            value:
                                              row.contact_status_updated_at,
                                            "show-icon": false,
                                            format: "MM/DD/YY"
                                          }
                                        })
                                      : _vm._e(),
                                    _c(
                                      "agent-contact-status-updated-at-date-picker",
                                      {
                                        attrs: {
                                          "contact-status-updated-at":
                                            row.contact_status_updated_at,
                                          agent: row
                                        },
                                        on: {
                                          "dates-updated": function(dates) {
                                            return _vm.updateContactStatusUpdatedAt(
                                              row,
                                              dates
                                            )
                                          }
                                        }
                                      }
                                    ),
                                    row.contact_status_updated_at
                                      ? _c("q-icon", {
                                          staticClass: "ml-1 cursor-pointer",
                                          attrs: {
                                            name: "close",
                                            size: "16px",
                                            color: "primary"
                                          },
                                          nativeOn: {
                                            click: function($event) {
                                              return (function() {
                                                return _vm.clearContactStatusUpdatedAt(
                                                  row
                                                )
                                              })($event)
                                            }
                                          }
                                        })
                                      : _vm._e()
                                  ],
                                  1
                                )
                              ]
                            )
                          ]
                        }
                      },
                      {
                        key: "cell-markets",
                        fn: function(ref) {
                          var row = ref.row
                          return [
                            _vm._v(
                              "\n              " +
                                _vm._s(
                                  (row.markets || [])
                                    .map(function(m) {
                                      return m.name
                                    })
                                    .join(", ")
                                ) +
                                "\n            "
                            )
                          ]
                        }
                      },
                      {
                        key: "cell-is_periodic_inspection_capable",
                        fn: function(ref) {
                          var row = ref.row
                          return [
                            _c(
                              "q-chip",
                              {
                                attrs: {
                                  dense: "",
                                  color: row.is_periodic_inspection_capable
                                    ? "positive"
                                    : "negative"
                                }
                              },
                              [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(
                                      row.is_periodic_inspection_capable
                                        ? "Capable"
                                        : "Incapable"
                                    ) +
                                    "\n              "
                                )
                              ]
                            )
                          ]
                        }
                      },
                      {
                        key: "cell-is_mimo_inspection_capable",
                        fn: function(ref) {
                          var row = ref.row
                          return [
                            _c(
                              "q-chip",
                              {
                                attrs: {
                                  dense: "",
                                  color: row.is_mimo_inspection_capable
                                    ? "positive"
                                    : "negative"
                                }
                              },
                              [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(
                                      row.is_mimo_inspection_capable
                                        ? "Capable"
                                        : "Incapable"
                                    ) +
                                    "\n              "
                                )
                              ]
                            )
                          ]
                        }
                      },
                      {
                        key: "cell-is_vacancy_check_inspection_capable",
                        fn: function(ref) {
                          var row = ref.row
                          return [
                            _c(
                              "q-chip",
                              {
                                attrs: {
                                  dense: "",
                                  color: row.is_vacancy_check_inspection_capable
                                    ? "positive"
                                    : "negative"
                                }
                              },
                              [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(
                                      row.is_vacancy_check_inspection_capable
                                        ? "Capable"
                                        : "Incapable"
                                    ) +
                                    "\n              "
                                )
                              ]
                            )
                          ]
                        }
                      },
                      {
                        key: "cell-is_marketing_photos_capable",
                        fn: function(ref) {
                          var row = ref.row
                          return [
                            _c(
                              "q-chip",
                              {
                                attrs: {
                                  dense: "",
                                  color: row.is_marketing_photos_capable
                                    ? "positive"
                                    : "negative"
                                }
                              },
                              [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(
                                      row.is_marketing_photos_capable
                                        ? "Capable"
                                        : "Incapable"
                                    ) +
                                    "\n              "
                                )
                              ]
                            )
                          ]
                        }
                      },
                      {
                        key: "cell-is_tours_capable",
                        fn: function(ref) {
                          var row = ref.row
                          return [
                            _c(
                              "q-chip",
                              {
                                attrs: {
                                  dense: "",
                                  color: row.is_tours_capable
                                    ? "positive"
                                    : "negative"
                                }
                              },
                              [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(
                                      row.is_tours_capable
                                        ? "Capable"
                                        : "Incapable"
                                    ) +
                                    "\n              "
                                )
                              ]
                            )
                          ]
                        }
                      },
                      {
                        key: "cell-actions",
                        fn: function(ref) {
                          var row = ref.row
                          return [
                            _c("q-btn", {
                              staticClass: "q-mr-sm",
                              attrs: {
                                size: "sm",
                                rounded: "",
                                label: "Edit",
                                outline: "",
                                color: "black",
                                icon: "edit"
                              },
                              nativeOn: {
                                click: function($event) {
                                  _vm.openEditModal(row)
                                }
                              }
                            }),
                            !row.verified
                              ? _c("q-btn", {
                                  staticClass: "q-ml-sm",
                                  attrs: {
                                    disable: _vm.disabled,
                                    size: "sm",
                                    rounded: "",
                                    outline: "",
                                    color: "positive",
                                    icon: "mail",
                                    label: "Resend Invite"
                                  },
                                  nativeOn: {
                                    click: function($event) {
                                      _vm.sendVerificationEmail(row.id)
                                    }
                                  }
                                })
                              : _vm._e()
                          ]
                        }
                      }
                    ])
                  })
                ],
                1
              )
            ]
          )
        ])
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }